import FavoriteAction from './FavoriteAction.vue'
import TestDriveAction from './TestDriveAction.vue'

export default {
  name: 'ActionButtonGroup',
  buttons: [
    FavoriteAction,
    TestDriveAction
  ]
}
